export function extractResErrorMessage(
  message?: string | { field: string; constraints: string }[],
) {
  if (Array.isArray(message)) {
    const error: Record<string, string> = {};

    message.forEach((r) => (error[r.field] = r.constraints));
    return error;
  }

  return message;
}
